import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useRoomTypeLegendStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    ...shorthands.padding(tokens.spacingVerticalS, '0'),
  },
  item: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  swatch: {
    width: '12px',
    height: '12px',
    ...shorthands.borderRadius('2px'),
  },
  label: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground2,
  },
  largeIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    marginLeft: 'auto',
    fontSize: fontScale.caption,
    ...shorthands.padding(tokens.spacingVerticalXS, tokens.spacingHorizontalM),
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke2),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  largeSwatch: {
    width: '12px',
    height: '12px',
    ...shorthands.borderRadius('2px'),
    backgroundColor: tokens.colorPaletteRedBackground2,
  },
  largeText: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorPaletteRedForeground1,
  },
  largeThreshold: {
    color: tokens.colorNeutralForeground3,
  },
  rootResponsive: {
    '@media (max-width: 768px)': {
      gap: tokens.spacingHorizontalS,
    },
  },
});
